import { render, staticRenderFns } from "./BackToAct.vue?vue&type=template&id=7541310b&scoped=true"
import script from "./BackToAct.vue?vue&type=script&lang=js"
export * from "./BackToAct.vue?vue&type=script&lang=js"
import style0 from "./BackToAct.vue?vue&type=style&index=0&id=7541310b&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7541310b",
  null
  
)

export default component.exports